import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Col, Row, Card, CardBody, Button, Spinner, Input, Modal, ModalHeader, ModalBody } from 'reactstrap';

import { Check, X } from 'react-feather';
import Moment from 'react-moment';

import ReactTooltip from 'react-tooltip';

import { connect } from 'react-redux';

import {
  PaymentElement,
  Elements,
  ElementsConsumer,
} from '@stripe/react-stripe-js';

import { loadStripe } from '@stripe/stripe-js';

// import SetupIntents from './SetupIntents';

import {
  getCompanySubscription,
  createCompanySubscription,
  updateSubscriptionSetup,
} from '../../../../actions/company';

import {
  getSubscriptionTooltips,
} from '../../../../actions/contentManagement';

const TableHeight = 500;

const pound = `${'\u00A3'}`;

let stripePromise;

class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spinner: null,
    };
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { stripe, elements, clientSecret, campaignId, paymentFinished, isSetupRequest, history } = this.props;

    if (elements == null) {
      return;
    }

    this.setState({ spinner: true });

    // Trigger form validation and wallet collection
    const { error: submitError } = await elements.submit();
    if (submitError) {
      console.log('submitError', submitError);
      // Show error to your customer

      this.setState({ spinner: null });

      return;
    }

    const { hostname } = window.location;

    if (isSetupRequest) {
      let return_url = `https://${hostname}/payment-request-success/${campaignId}`;
      let return_url_redirect = `/payment-request-success/${campaignId}`;

      if (hostname === 'localhost') {
        return_url = `https://${hostname}/payment-request-success/${campaignId}`;
        return_url_redirect = `/payment-request-success/${campaignId}`;
      }

      const { error } = await stripe.confirmSetup({
        elements,
        clientSecret,
        redirect: 'if_required',
        confirmParams: {
          return_url: return_url,
        },
      });

      this.setState({ spinner: null });

      if (error) {
        console.log('error', error);
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
      } else {
        console.log('retuern url', return_url, return_url_redirect);

        await paymentFinished(return_url_redirect);

        // history.push(return_url_redirect);
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
      }
    } else {
      let return_url = `https://${hostname}/payment-success/${campaignId}`;

      if (hostname === 'localhost') {
        return_url = `http://${hostname}:3000/payment-success/${campaignId}`;
      }

      const { error } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: return_url, // `https://steppr-client.web.app/payment-success/${campaignId}`,
        },
      });

      this.setState({ spinner: null });

      if (error) {
        console.log('error', error);
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
      } else {
        console.log('retuern url');
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
      }
    }

    // paymentFinished();
  };

  render() {
    const { stripe, processingPaymentAmount } = this.props;
    const { spinner } = this.state;

    const { hostname } = window.location;

    let processingPaymentAmountParsed;

    if (processingPaymentAmount) {
      processingPaymentAmountParsed = (processingPaymentAmount).toFixed(2);
    }

    return (
      <form onSubmit={this.handleSubmit}>
        <PaymentElement />
        <button className="stripe-pay-button" type="submit" disabled={!stripe}>
          <span className="stripe-pay-button-title">
            {`Pay ${pound}${processingPaymentAmount ? processingPaymentAmountParsed : ''}`}
            {(spinner) ? (
              <Spinner animation="border" variant="primary" style={{ width: '1.2rem', height: '1.2rem', marginLeft: 10 }}> {''} </Spinner>
            ) : (null)}
          </span>
        </button>
      </form>
    );
  }
}

const InjectedCheckoutForm = ({ customerSecret, processingPaymentAmount, campaignId, isSetupRequest, paymentFinished, history }) => (
  <ElementsConsumer>
    {({ stripe, elements }) => (
      <CheckoutForm
        campaignId={campaignId}
        stripe={stripe}
        elements={elements}
        clientSecret={customerSecret}
        processingPaymentAmount={processingPaymentAmount}
        isSetupRequest={isSetupRequest}
        paymentFinished={paymentFinished}
        history={history}
      />
    )}
  </ElementsConsumer>
);

class Subscriptions extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    fetchStripeLoginLink: PropTypes.func.isRequired,
    getStripeCompanyStatus: PropTypes.func.isRequired,
    addStripeAccount: PropTypes.func.isRequired,
    getSinglePayment: PropTypes.func.isRequired,
    fetchPaymentTooltips: PropTypes.func.isRequired,
    resendEmail: PropTypes.func.isRequired,
    fetchLinkedAPIs: PropTypes.func.isRequired,
    checkCompStatus: PropTypes.func.isRequired,
    openCodePreview: PropTypes.func.isRequired,
    fetchSubscriptionTooltips: PropTypes.func.isRequired,
    updateSubscriptionSetupFunc: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
  };

  constructor(props) {
    super(props);

    const startDate = new Date();
    startDate.setDate(startDate.getDate() - (365 * 2));

    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 1);

    this.state = {
      error: null,
      loading: false,
      showNoPermission: false,
      dontShowPage: false,
      startDate: startDate,
      endDate: endDate,
      sortColumn: 'paymentDate',
      sortType: 'desc',
      codePreviews: {},
      phoneCode: [],
      intervalId: null,
      checkCount: 0,
      redeemedOnly: false,
      timeframe: 'month',
    };
  }

  componentDidMount() {
    const { user, history, getSubscription, adminViewAsCompany, fetchSubscriptionTooltips, updateSubscriptionSetupFunc } = this.props;

    fetchSubscriptionTooltips();

    if (user && Object.keys(user).length > 0) {
      console.log('user.company', user.company, adminViewAsCompany);
      if (user.company) {
        if (user.role === 'teamOwner' || user.role === 'linkedCompanyUser') {
          getSubscription(user.company);
          updateSubscriptionSetupFunc({ companyId: user.company });

          const promise1 = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

          Promise.all([promise1]).then((promisesRes) => {
            promisesRes.map((resp, index) => {
              if (index === 0) {
                const stripe = resp;

                stripePromise = stripe;
              }
            });
          });

          this.setState({ showNoPermission: false, dontShowPage: false });
        } else {
          const { roles } = this.props;

          if (roles && roles[user.role] && roles[user.role].permissions && roles[user.role].permissions.payments) {
            getSubscription(user.company);
            updateSubscriptionSetupFunc({ companyId: user.company });

            const promise1 = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

            Promise.all([promise1]).then((promisesRes) => {
              promisesRes.map((resp, index) => {
                if (index === 0) {
                  const stripe = resp;

                  stripePromise = stripe;
                }
              });
            });

            if (roles[user.role].permissions.payments === 2) {
              this.setState({ showNoPermission: false, dontShowPage: false });
            } else {
              this.setState({ showNoPermission: true, dontShowPage: false });
            }
          } else {
            this.setState({ showNoPermission: true, dontShowPage: true });
          }
        }
      } else if (adminViewAsCompany) {
        getSubscription(adminViewAsCompany);
        updateSubscriptionSetupFunc({ companyId: adminViewAsCompany });

        const promise1 = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

        Promise.all([promise1]).then((promisesRes) => {
          promisesRes.map((resp, index) => {
            if (index === 0) {
              const stripe = resp;

              stripePromise = stripe;
            }
          });
        });
      }
    } else {
      history.push('/');
    }
  }

  onScroll = (x, y) => {
    const { payments } = this.props;
    let contextHeight = payments.length * 46;
    let top = Math.abs(y);

    if (contextHeight - top - TableHeight < 0) {

      if (this.state.scrollTimeout) {
        clearTimeout(this.state.scrollTimeout);
      }

      this.setState({
        scrollTimeout: setTimeout(() => {
          this.getMorePayments();
        }, 700)
      });
    }
  };

  openResendEmail = (chargeId, dbId) => {
    this.setState({ resendEmailOpen: true, resendEmailChargeId: chargeId, resendEmailDbId: dbId, resendEmailProcessing: null, resendEmailError: null });
  }

  closeResendEmail = () => {
    this.setState({ resendEmailOpen: null, resendEmailChargeId: null, resendEmailDbId: null, resendEmailProcessing: null, resendEmailError: null });
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  handleSelect = event => {
    const { linkedCompaniesAPIs } = this.props;
    const { value } = event.target;

    if (value === 'all') {
      this.setState({ redeemedByFilter: null });
    } else {
      this.setState({ redeemedByFilter: value });
    }
    // this.setState({ alertType: event.target.value });
  };

  changeSubscription = (type) => {
    const { createSubscription, adminViewAsCompany, user } = this.props;
    const { timeframe } = this.state;

    console.log('changeSubscription', type, adminViewAsCompany);

    if (adminViewAsCompany) {
      createSubscription(adminViewAsCompany, type, timeframe).then((res) => {
        const { clientSecret, amount, sesionData } = res;

        console.log('createSubscription res', res);

        if (sesionData && sesionData.url) {
          window.location.replace(sesionData.url);
        } else if (clientSecret) {
          this.setState({ showStripePaymentFlow: true, clientSecret, processingPaymentAmount: amount || '', manageModalSpinner: null });
        }
      });
    } else {
      createSubscription(user.company, type, timeframe).then((res) => {
        const { clientSecret, amount, sesionData } = res;

        console.log('createSubscription res', res);

        if (sesionData) {
          window.location.replace(sesionData.url);
        } else if (clientSecret) {
          this.setState({ showStripePaymentFlow: true, clientSecret, processingPaymentAmount: amount || '', manageModalSpinner: null });
        }
      });
    }
  }

  closePaymentModal = () => {
    this.setState({ showStripePaymentFlow: false, clientSecret: null, processingPaymentAmount: null, manageModalSpinner: null });
  }

  paymentFinished = (res) => {
    console.log('paymentFinished', res);
  }

  openManageModal = () => {
    const { companySubscription } = this.props;

    this.setState({ manageModalSpinner: true });

    if (companySubscription && companySubscription.subcriptionType) {
      this.changeSubscription('starter');
    } else {
      this.changeSubscription('free');
    //  this.setState({ manageModalOpen: true });
    }
    
  }

  closeManageModal = () => {
    this.setState({ manageModalOpen: false, manageModalSpinner: null });
  }

  toggleTimeframe = (time) => {
    this.setState({ timeframe: time });
  }

  render() {
    const {
      adminViewAsCompany,
      companySubscription,
      history,

      tooltips,
    } = this.props;
    const {
      showNoPermission,
      dontShowPage,
      
      showStripePaymentFlow,
      clientSecret,
      processingPaymentAmount,
      manageModalOpen,
      timeframe,

      manageModalSpinner,
    } = this.state;

    if (dontShowPage) {
      return (
        <div>
          <Card>
            <CardBody>
              You don't have permissions to view payments
            </CardBody>
          </Card>
        </div>
      );
    }

    console.log('companySubscription', companySubscription);

    return (
      <div className="subscriptions">
        <Row className="subscriptions-header">
          <Col xs="12">
            <Row>
              <Col xs="6" className="subscriptions-header-left">
                <div className="subscriptions-current-plan">
                  {`Your current plan: `}
                  <span style={{ textTransform: 'capitalize' }}> {`${(companySubscription && companySubscription.subcriptionType) ? companySubscription.subcriptionType : 'Free'}`}</span>
                </div>
                <div className="subscriptions-renews-on">{`Renews on: `}
                  {(companySubscription && companySubscription.subcriptionType) ? (
                  <Moment format="DD/MM/YYYY" locale="=uk">
                    {companySubscription.renewsOn *1000}
                  </Moment>
                ) : '-'}</div>
              </Col>
              <Col xs="6" className="subscriptions-header-right">
                <Button className="subscriptions-manage-plan-button" onClick={this.openManageModal}>
                  {manageModalSpinner ? (
                    <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                  ) : (null)}
                  Manage plan
                </Button>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <div className="subscriptions-timeframe">
                  <Button color={timeframe === 'month' ? 'primary' : 'secondary'} className={`subscriptions-timeframe-month ${timeframe === 'month' ? 'subscriptions-timeframe-active' : ''}`} onClick={() => this.toggleTimeframe('month')}> Monthly</Button>
                  <Button color={timeframe === 'year' ? 'primary' : 'secondary'} className={`subscriptions-timeframe-year ${timeframe === 'year' ? 'subscriptions-timeframe-active' : ''}`} onClick={() => this.toggleTimeframe('year')}> Yearly - save 17%</Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='additionalPromotion'>
          <span>{tooltips.additionalPromotion ? tooltips.additionalPromotion.value : ''}</span>
        </ReactTooltip>
        <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='brandedCampaignURL'>
          <span>{tooltips.brandedCampaignURL ? tooltips.brandedCampaignURL.value : ''}</span>
        </ReactTooltip>
        <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='fastSupport'>
          <span>{tooltips.fastSupport ? tooltips.fastSupport.value : ''}</span>
        </ReactTooltip>
        <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='featuredListing'>
          <span>{tooltips.featuredListing ? tooltips.featuredListing.value : ''}</span>
        </ReactTooltip>
        <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='freePromotion'>
          <span>{tooltips.freePromotion ? tooltips.freePromotion.value : ''}</span>
        </ReactTooltip>
        <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='giftingAndLoyalty'>
          <span>{tooltips.giftingAndLoyalty ? tooltips.giftingAndLoyalty.value : ''}</span>
        </ReactTooltip>
        <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='immediatePayments'>
          <span>{tooltips.immediatePayments ? tooltips.immediatePayments.value : ''}</span>
        </ReactTooltip>
        <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='priorityListingBadge'>
          <span>{tooltips.priorityListingBadge ? tooltips.priorityListingBadge.value : ''}</span>
        </ReactTooltip>
        <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='vouchReach'>
          <span>{tooltips.vouchReach ? tooltips.vouchReach.value : ''}</span>
        </ReactTooltip>
        <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='zeroCommission'>
          <span>{tooltips.zeroCommission ? tooltips.zeroCommission.value : ''}</span>
        </ReactTooltip>
        <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='extraCustomerChoice'>
          <span>{tooltips.extraCustomerChoice ? tooltips.extraCustomerChoice.value : ''}</span>
        </ReactTooltip>

        

        {/*
        <Card size="md" className="subscriptions-card">
          <CardBody style={{ paddingTop: 0 }}>
            <Row className="subscriptions-table">
              <Col xs="12">
                <Row className="subscriptions-table-header-row">
                  <Col xs="3" className="subscriptions-table-header-row-plan">
                    Growth Toolkit Plans
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-header-row-best-value"></div>
                    <div className="subscriptions-table-header-row-name">Free</div>
                    <div className="subscriptions-table-header-row-price">{pound}0</div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-header-row-best-value"></div>
                    <div className="subscriptions-table-header-row-name">Starter</div>
                    {timeframe === 'year' ? (
                      <div className = "subscriptions-table-header-row-price">{pound}100<span>/year</span></div>
                    ): (
                      <div className="subscriptions-table-header-row-price">{pound}10<span>/mo</span></div>
                    )}
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-header-row-best-value">Best value</div>
                    <div className="subscriptions-table-header-row-name">Growth</div>
                    {timeframe === 'year' ? (
                      <div className="subscriptions-table-header-row-price">{pound}300<span>/year</span></div>
                    ): (
                      <div className = "subscriptions-table-header-row-price">{ pound }30<span>/mo</span></div>
                    )}
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-header-row-best-value"></div>
                    <div className="subscriptions-table-header-row-name">Pro</div>
                    {timeframe === 'year' ? (
                      <div className="subscriptions-table-header-row-price">{pound}900<span>/year</span></div>
                    ) : (
                      <div className="subscriptions-table-header-row-price">{pound}90<span>/mo</span></div>
                    )}
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-header-row-best-value"></div>
                    <div className="subscriptions-table-header-row-name">Enterprise</div>
                    {timeframe === 'year' ? (
                      <div className="subscriptions-table-header-row-price">{pound}2,000<span>/year</span></div>
                    ): (
                      <div className = "subscriptions-table-header-row-price">{ pound }200<span>/mo</span></div>
                    )}
                  </Col>
                </Row>

                <Row className="subscriptions-table-row">
                  <Col xs="3" className="subscriptions-table-row-name">
                    Free Promotion
                    <div className="subscriptions-info-icon" data-tip data-for='freePromotion' for="freePromotion">i</div>
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-check"><Check/></div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                </Row>

                <Row className="subscriptions-table-row">
                  <Col xs="3" className="subscriptions-table-row-name">
                    Zero Commission
                    <div className="subscriptions-info-icon" data-tip data-for='zeroCommission' for="zeroCommission">i</div>
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                </Row>

                <Row className="subscriptions-table-row">
                  <Col xs="3" className="subscriptions-table-row-name">
                    Extra Customer Choice
                    <div className="subscriptions-info-icon" data-tip data-for='extraCustomerChoice' for="extraCustomerChoice">i</div>
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                </Row>

                <Row className="subscriptions-table-row">
                  <Col xs="3" className="subscriptions-table-row-name">
                    Gifting & Loyalty Tools
                    <div className="subscriptions-info-icon" data-tip data-for='giftingAndLoyalty' for="fiftingAndLoyalty">i</div>
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                </Row>

                <Row className="subscriptions-table-row">
                  <Col xs="3" className="subscriptions-table-row-name">
                    Immediate Payments
                    <div className="subscriptions-info-icon" data-tip data-for='immediatePayments' for="immediatePayments">i</div>
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                </Row>

                <Row className="subscriptions-table-row">
                  <Col xs="3" className="subscriptions-table-row-name"> 
                    Fast Support
                    <div className="subscriptions-info-icon" data-tip data-for='fastSupport' for="fastSupport">i</div>
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                </Row>

                <Row className="subscriptions-table-row">
                  <Col xs="3" className="subscriptions-table-row-name">
                    Branded Campaign URL
                    <div className="subscriptions-info-icon" data-tip data-for='brandedCampaignURL' for="brandedCampaignURL">i</div>
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                </Row>

                <Row className="subscriptions-table-row">
                  <Col xs="3" className="subscriptions-table-row-name">
                    Additional Promotion
                    <div className="subscriptions-info-icon" data-tip data-for='additionalPromotion' for="aditionalPromotion">i</div>
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                </Row>
                

                <Row className="subscriptions-table-row"> 
                  <Col xs="3" className="subscriptions-table-row-name">
                    Priority Listing Badge
                    <div className="subscriptions-info-icon" data-tip data-for='priorityListingBadge' for="priorityListingBadge">i</div>
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                </Row>

                <Row className="subscriptions-table-row">
                  <Col xs="3" className="subscriptions-table-row-name">
                    Featured Placement
                    <div className="subscriptions-info-icon" data-tip data-for='featuredListing' for="featuredListing">i</div>
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                </Row>

                <Row className="subscriptions-table-row subscriptions-table-row-last">
                  <Col xs="3" className="subscriptions-table-row-name">
                    VouchReach
                    <div className="subscriptions-info-icon" data-tip data-for='vouchReach' for="vouchReach">i</div>
                    <div style={{ fontSize: 12, fontWeight: 600, fontStyle: 'italic' }}>Voucher Outreach Emails</div>
                  </Col>
                  <Col className="subscriptions-table-row-free">
                    <div className="subscriptions-table-check"><Check /></div>
                    <div className="subscriptions-table-row-last-info1">5/mo</div>
                  </Col>
                  <Col className="subscriptions-table-row-starter">
                    <div className="subscriptions-table-check"><Check /></div>
                    <div className="subscriptions-table-row-last-info1">250/mo</div>
                  </Col>
                  <Col className="subscriptions-table-row-growth">
                    <div className="subscriptions-table-check"><Check /></div>
                    <div className="subscriptions-table-row-last-info1">1k/mo</div>
                  </Col>
                  <Col className="subscriptions-table-row-pro">
                    <div className="subscriptions-table-check"><Check /></div>
                    <div className="subscriptions-table-row-last-info1">10k/mo</div>
                  </Col>
                  <Col className="subscriptions-table-row-enterprise">
                    <div className="subscriptions-table-check"><Check /></div>
                    <div className="subscriptions-table-row-last-info1">50k/mo</div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card> */}



        <Card size="md" className="subscriptions-card">
          <CardBody style={{ paddingTop: 0 }}>
            <Row className="subscriptions-table">
              <Col xs="3" className="subscriptions-table-row">
                <Row>
                  <Col xs="12" className="subscriptions-table-header-row subscriptions-table-header-row-first">Growth Toolkit Plans</Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <span data-tip data-for='freePromotion' for="freePromotion">Free Promotion</span>
                    <div className="subscriptions-info-icon" data-tip data-for='freePromotion' for="freePromotion">i</div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <span data-tip data-for='zeroCommission' for="zeroCommission">Zero Commission</span>
                    <div className="subscriptions-info-icon" data-tip data-for='zeroCommission' for="zeroCommission">i</div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <span data-tip data-for='extraCustomerChoice' for="extraCustomerChoice">Extra Customer Choice</span>
                    <div className="subscriptions-info-icon" data-tip data-for='extraCustomerChoice' for="extraCustomerChoice">i</div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <span data-tip data-for='giftingAndLoyalty' for="giftingAndLoyalty">Gifting & Loyalty Tools</span>
                    <div className="subscriptions-info-icon" data-tip data-for='giftingAndLoyalty' for="fiftingAndLoyalty">i</div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <span data-tip data-for='immediatePayments' for="immediatePayments">Immediate Payments</span>
                    <div className="subscriptions-info-icon" data-tip data-for='immediatePayments' for="immediatePayments">i</div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <span data-tip data-for='fastSupport' for="fastSupport">Fast Support</span>
                    <div className="subscriptions-info-icon" data-tip data-for='fastSupport' for="fastSupport">i</div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <span data-tip data-for='brandedCampaignURL' for="brandedCampaignURL">Branded Campaign URL</span>
                    <div className="subscriptions-info-icon" data-tip data-for='brandedCampaignURL' for="brandedCampaignURL">i</div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <span data-tip data-for='additionalPromotion' for="additionalPromotion">Additional Promotion</span>
                    <div className="subscriptions-info-icon" data-tip data-for='additionalPromotion' for="aditionalPromotion">i</div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <span data-tip data-for='priorityListingBadge' for="priorityListingBadge">Priority Listing Badge</span>
                    <div className="subscriptions-info-icon" data-tip data-for='priorityListingBadge' for="priorityListingBadge">i</div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <span data-tip data-for='featuredListing' for="featuredListing">Featured Placement</span>
                    <div className="subscriptions-info-icon" data-tip data-for='featuredListing' for="featuredListing">i</div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box subscriptions-table-box-last">
                    <span data-tip data-for='vouchReach' for="vouchReach">VouchReach</span>
                    <div className="subscriptions-info-icon" data-tip data-for='vouchReach' for="vouchReach">i</div>
                    <div style={{ fontSize: 12, fontWeight: 600, fontStyle: 'italic', marginTop: -10 }}>Voucher Outreach Emails</div>
                  </Col>
                </Row>
              </Col>
                <Col className="subscriptions-table-row">
                <Row>
                  <Col xs="12" className="subscriptions-table-header-row">
                    <div className="subscriptions-table-header-row-best-value"></div>
                    <div className="subscriptions-table-header-row-name">Free</div>
                    <div className="subscriptions-table-header-row-price">{pound}0</div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check" style={{ paddingTop: 0, fontWeight: 500 }}><Check /> <span style={{ color: '#000' }}>Standard</span></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box subscriptions-table-box-last">
                    <div className="subscriptions-table-check"><Check /></div>
                    <div className="subscriptions-table-row-last-info1">2/mo</div>
                  </Col>
                </Row>
              </Col>
              <Col className="subscriptions-table-row">
                <Row>
                  <Col xs="12" className="subscriptions-table-header-row">
                    <div className="subscriptions-table-header-row-best-value"></div>
                    <div className="subscriptions-table-header-row-name">Starter</div>
                    {timeframe === 'year' ? (
                      <div className="subscriptions-table-header-row-price">{pound}150<span>/year</span></div>
                    ) : (
                      <div className="subscriptions-table-header-row-price">{pound}15<span>/mo</span></div>
                    )}
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box subscriptions-table-box-last">
                    <div className="subscriptions-table-check"><Check /></div>
                    <div className="subscriptions-table-row-last-info1">100/mo</div>
                  </Col>
                </Row>
              </Col>
              <Col className="subscriptions-table-row subscriptions-table-row-growth">
                <Row>
                  <Col xs="12" className="subscriptions-table-header-row">
                    <div className="subscriptions-table-header-row-best-value">Best value</div>
                    <div className="subscriptions-table-header-row-name">Growth</div>
                    {timeframe === 'year' ? (
                      <div className="subscriptions-table-header-row-price">{pound}490<span>/year</span></div>
                    ) : (
                      <div className="subscriptions-table-header-row-price">{pound}49<span>/mo</span></div>
                    )}
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-cross"><X /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box subscriptions-table-box-last">
                    <div className="subscriptions-table-check"><Check /></div>
                    <div className="subscriptions-table-row-last-info1">2k/mo</div>
                  </Col>
                </Row>
              </Col>
              <Col className="subscriptions-table-row">
                <Row>
                  <Col xs="12" className="subscriptions-table-header-row">
                    <div className="subscriptions-table-header-row-best-value"></div>
                    <div className="subscriptions-table-header-row-name">Pro</div>
                    {timeframe === 'year' ? (
                      <div className="subscriptions-table-header-row-price">{pound}990<span>/year</span></div>
                    ) : (
                      <div className="subscriptions-table-header-row-price">{pound}99<span>/mo</span></div>
                    )}
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check" style={{ paddingTop: 0, fontWeight: 500 }}><Check /> <span style={{ color: '#000' }}>Priority</span></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box subscriptions-table-box-last">
                    <div className="subscriptions-table-check"><Check /></div>
                    <div className="subscriptions-table-row-last-info1">10k/mo</div>
                  </Col>
                </Row>
              </Col>
              <Col className="subscriptions-table-row">
                <Row>
                  <Col xs="12" className="subscriptions-table-header-row">
                    <div className="subscriptions-table-header-row-best-value"></div>
                    <div className="subscriptions-table-header-row-name">Enterprise</div>
                    {timeframe === 'year' ? (
                      <div className="subscriptions-table-header-row-price">{pound}2,000<span>/year</span></div>
                    ) : (
                      <div className="subscriptions-table-header-row-price">{pound}200<span>/mo</span></div>
                    )}
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check" style={{ paddingTop: 0, fontWeight: 500 }}><Check /> <span style={{ color: '#000' }}>Priority</span></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box">
                    <div className="subscriptions-table-check"><Check /></div>
                  </Col>
                  <Col xs="12" className="subscriptions-table-box subscriptions-table-box-last">
                    <div className="subscriptions-table-check"><Check /></div>
                    <div className="subscriptions-table-row-last-info1">50k/mo</div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>


        {/* 
        <Card size="md" className="subscriptions-card">
          <CardBody style={{ paddingTop: 0 }}>
            {tooltips ? (Object.keys(tooltips).map((key) => (
              <Row>
                <Col xs="3">{tooltips[key].name}</Col>
                <Col xs="9">{tooltips[key].value}</Col>
              </Row>
            ))) : (null)}
          </CardBody>
        </Card > */}


        <Modal size="md" isOpen={(manageModalOpen)} toggle={this.closeManageModal} className="stripe-pay-modal">
          <ModalHeader toggle={this.closePaymentModal}>
            Manage plan
          </ModalHeader>
          <ModalBody>
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <Button
                className={`subscriptions-manage-plan-modal-button ${(companySubscription && companySubscription.subcriptionType && companySubscription.subcriptionType === 'starter') ? 'subscriptions-manage-plan-modal-button-active' : ''}`}
                onClick={() => this.changeSubscription('starter')}
                disabled={companySubscription && companySubscription.subcriptionType && companySubscription.subcriptionType === 'starter'}
              >
                Starter
              </Button>
              <Button
                className={`subscriptions-manage-plan-modal-button ${(companySubscription && companySubscription.subcriptionType && companySubscription.subcriptionType === 'growth') ? 'subscriptions-manage-plan-modal-button-active' : ''}`}
                onClick={() => this.changeSubscription('growth')} disabled={companySubscription && companySubscription.subcriptionType && companySubscription.subcriptionType === 'growth'}
              >
                Growth
              </Button>
              <Button
                className={`subscriptions-manage-plan-modal-button ${(companySubscription && companySubscription.subcriptionType && companySubscription.subcriptionType === 'pro') ? 'subscriptions-manage-plan-modal-button-active' : ''}`}
                onClick={() => this.changeSubscription('pro')} disabled={companySubscription && companySubscription.subcriptionType && companySubscription.subcriptionType === 'pro'}
              >
                Pro
              </Button>
              <Button
                className={`subscriptions-manage-plan-modal-button ${(companySubscription && companySubscription.subcriptionType && companySubscription.subcriptionType === 'enterprise') ? 'subscriptions-manage-plan-modal-button-active' : ''}`}
                onClick={() => this.changeSubscription('enterprise')} disabled={companySubscription && companySubscription.subcriptionType && companySubscription.subcriptionType === 'enterprise'}
              >
                Enterprise
              </Button>
            </Elements>
          </ModalBody>
        </Modal>

        <Modal size="md" isOpen={(showStripePaymentFlow && clientSecret)} toggle={this.closeModal} className="stripe-pay-modal">
          <ModalHeader toggle={this.closePaymentModal}>
            Subscribe to plan
          </ModalHeader>
          <ModalBody>
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <InjectedCheckoutForm
                clientSecret={clientSecret}
                processingPaymentAmount={processingPaymentAmount}
                paymentFinished={this.paymentFinished}
                history={history}
              />
            </Elements>
          </ModalBody>
        </Modal>
      </div >
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  company: state.company.company || {},
  adminViewAsCompany: state.admin.adminViewAsCompany || null,
  companySubscription: state.company.companySubscription || {},
  tooltips: state.contentManagement.subscriptionTooltips || {},
  tootipsSortedArray: state.contentManagement.subscriptionTooltipsSortedArray || [],
});

const mapDispatchToProps = {
  getSubscription: getCompanySubscription,
  createSubscription: createCompanySubscription,
  fetchSubscriptionTooltips: getSubscriptionTooltips,
  updateSubscriptionSetupFunc: updateSubscriptionSetup,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Subscriptions));
